import { Action, Selector, State, StateContext } from '@ngxs/store';

export class AppStateModel {
  language?: string;
}

export class SetLanguage {
  static readonly type = '[App] SetLanguage';
  constructor(public language: string) {}
}

@State<AppStateModel>({
  name: 'app'
})
export class AppState {
  constructor() {}

  @Selector()
  static state(state: AppStateModel): AppStateModel {
    return state;
  }

  @Action(SetLanguage)
  setLanguage(
    { patchState }: StateContext<AppStateModel>,
    payload: SetLanguage
  ) {
    return patchState({ language: payload.language });
  }
}
